export default {
  detailsTitleUpgraded: {
    id: 'express_replacement_details_title_upgraded',
    defaultMessage:
      "We've upgraded the condition of your replacement to {grade, html}, for free!",
  },
  informationSectionTitle: {
    id: 'express_replacement_details_information_section_title',
    defaultMessage: 'How does it work?',
  },
  informationSectionDescription: {
    id: 'express_replacement_details_information_section_description',
    defaultMessage:
      "We send the replacement before you return your original, so there's no gap where you're without a device.",
  },
  replacementOrderSectionTitle: {
    id: 'express_replacement_details_order_section_title',
    defaultMessage: 'Your replacement details:',
  },
  faqCta: {
    id: 'express_replacement_details_faq_cta',
    defaultMessage: 'View FAQ',
  },
  getStartedCta: {
    id: 'express_replacement_details_get_started_cta',
    defaultMessage: 'Get started',
  },
}
